import { useState } from 'react'

// Copies a SAP-grid table (tab-separated lines, see backend cmp_formato_sap) to the clipboard.
async function copiarTexto(texto) {
  try {
    await navigator.clipboard.writeText(texto)
  } catch {
    const ta = document.createElement('textarea')            // where the clipboard API is not allowed
    ta.value = texto
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
  }
}

export default function CopiarFormatoSap({ texto, cargar, children, hecho, className = '', disabled = false }) {
  const [estado, setEstado] = useState('')
  const copiar = async () => {
    setEstado('')
    try {
      await copiarTexto(texto ?? (await cargar()).texto)
      setEstado('ok')
      setTimeout(() => setEstado(''), 2500)
    } catch { setEstado('error') }
  }
  return (
    <button type="button" onClick={copiar} disabled={disabled}
      className={`px-3 py-1.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 ${className}`}>
      {estado === 'ok' ? `✓ ${hecho}` : estado === 'error' ? '⚠' : children}
    </button>
  )
}
